import { render, staticRenderFns } from "./MappingNew.vue?vue&type=template&id=0f959cf4"
import script from "./MappingNew.vue?vue&type=script&lang=js"
export * from "./MappingNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports